import * as React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, IconButton, Typography } from '@mui/material';
import { NotificationModel, NotificationModelType } from '../reducers/main/mainModel';
import { Sizes } from '../@shared/palette';
import { FlexBoxInline, SecondaryBtnSx } from '../@shared/templates';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

type AlertComponentType = {
    notification: NotificationModel,
    onClose?: (error: NotificationModel) => void,
    isClosable?: boolean
}

export const AlertComponent = (props: AlertComponentType) => {
    const getIcon = (type: NotificationModelType) => {
        switch (type) {
            case NotificationModelType.Error:
                return <ErrorOutlineOutlinedIcon sx={{ fontSize: Sizes.icon, color: getTextColor(type) }} />
            case NotificationModelType.Warning:
                return <WarningAmberIcon sx={{ fontSize: Sizes.icon, color: getTextColor(type) }} />
            case NotificationModelType.Success:
                return <CheckCircleOutlineOutlinedIcon sx={{ fontSize: Sizes.icon, color: getTextColor(type) }} />
            default:
                return <ErrorOutlineOutlinedIcon sx={{ fontSize: Sizes.icon, color: getTextColor(type) }} />
        }
    }

    const getTextColor = (type: NotificationModelType) => {
        switch (type) {
            case NotificationModelType.Error:
                return "rgb(95, 33, 32)"
            case NotificationModelType.Warning:
                return "rgb(102, 60, 0)"
            case NotificationModelType.Success:
                return "rgb(30, 70, 32)"
            default:
                return "rgb(95, 33, 32)"
        }
    }
    const getBorderColor = (type: NotificationModelType) => {
        switch (type) {
            case NotificationModelType.Error:
                return "rgb(243 214 214)"
            case NotificationModelType.Warning:
                return "rgb(242 216 182)"
            case NotificationModelType.Success:
                return "rgb(185 220 185)"
            default:
                return "rgb(243 214 214)"
        }
    }
    const getBackgroundColor = (type: NotificationModelType) => {
        switch (type) {
            case NotificationModelType.Error:
                return "rgb(253, 237, 237)"
            case NotificationModelType.Warning:
                return "rgb(255, 244, 229)"
            case NotificationModelType.Success:
                return "rgb(237, 247, 237)"
            default:
                return "rgb(253, 237, 237)"
        }
    }

    return <Box sx={{
        display: 'flex',
        gap: '10px',
        padding: '10px',
        backgroundColor: getBackgroundColor(props.notification.type),
        color: 'white',
        borderRadius: '5px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: "1px solid " + getBorderColor(props.notification.type),
    }} className={`${props.notification.markAsClosed ? "toast-exit" : "toast-enter"
        }`}>
        <Box sx={{ ...FlexBoxInline, gap: "10px" }}>
            {getIcon(props.notification.type)}
            <Typography sx={{
                fontSize: Sizes.textPrimary,
                color: getTextColor(props.notification.type),
            }}>{props.notification.message}</Typography>
        </Box>
        {props.onClose && <IconButton sx={{
            ...SecondaryBtnSx,
            color: getTextColor(props.notification.type),
            p: "5px",
            border: "none",
            "&:hover": {
                backgroundColor: 'rgba(255,255,255,0.7)'
            }
        }} aria-label="close" onClick={() => props.onClose!(props.notification)}>
            <ClearIcon sx={{ fontSize: Sizes.icon }} />
        </IconButton>}

    </Box>
}